import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';

function MethodPickup(props) {


    return(
        <div>
         MethodPickup
        </div>
    )

}

export default MethodPickup